module.exports = __webpack_public_path__ + "img/chengyun11.058a7a81.png";